<template>
    <div class="listmain ">
         <h1 class="firTitle">技能数据 </h1>
              <p>任意数据，该数据会通过语音服务透传给客户端，第三方开发技能的时候可以通过该字段往客户端进行信息的透传

              </p>

              <h5 class="thirdTitle">请求头信息：</h5>
              <p>POST : /intent/invoke HTTP/1.1
                <br>Content-Type : application/x-www-form-urlencoded;charset=UTF-8
                <br>Host : ovs.ainirobot.com
                <br>Content-Length:
                <br>Accept : application/json
                <br>Accept-Charset : utf-8

              </p>
               <h5 class="thirdTitle">请求内容格式规范及参数说明</h5>

              <h5 class="codeTitle">技能数据</h5>
              <highlight-code lang="javascript">
                  "skillData": {//Type:JSONObject
            //任意数据，该数据会通过语音服务透传给客户端，第三方开发技能的时候可以通过该字段往客户端进行信息的透传。
            "xiaoYaCompatible":{//Type:JSONObject,小雅兼容字段，该字段只针对于小雅进行使用，进行小雅协议的兼容。
                "code":String,//Type:String
                "desc":String,//Type:String
                "slots":JSONObject,//Type:JSONObject
                "data":Object,//Type:Object
                "preSpeeh":String,//Type:JSONObject
                "reportQueryHistory":String   //Type:JSONObject
            },
            "dialogCompatible":{//Type:JSONObject,对话兼容字段，pyskill中的所有数据都放到该字段中，JSONObject
            }
}

             </highlight-code>



    </div>
</template>

<script>
export default {
  name: "Ptjj"
};
</script>

<style  rel="stylesheet/scss" lang="scss" scoped>
h1,
h2,
h3,
h4,
h5 {
  padding: 0;
  margin: 0px;
  font-weight: normal;
}

ul,
li {
  list-style: none;
}

.listmain {
  font-size: 14px;
  line-height: 26px;
  .firTitle {
    font-size: 20px;
    color: #1e4d79;
    margin-bottom: 30px;
  }
  .sedTitle {
    font-size: 16px;
    font-weight: bold;
    padding-bottom: 10px;
    border-bottom: 1px solid #f3f3f3;
    margin-bottom: 15px;
    margin-top: 50px;
    &.fir {
      margin-top: 0px;
    }
  }
  .thirdTitle {
    margin-top: 50px;
    font-weight: bold;
    line-height: 26px;
  }
  .codeTitle {
    font-weight: bold;
    line-height: 26px;
  }
  pre {
    margin-top: 20px;
  }
  img {
    margin: 30px 0;
  }
  table,
  table tr th,
  table tr td {
    border: 1px solid #000;
    text-align: center;
  }
  table {
    line-height: 30px;
    width: 100%;
    border-collapse: collapse;
  }
}

.el-submenu .el-menu-item {
  min-width: 190px;
  background: #f5f5f5;
}

.el-submenu {
  min-width: 190px;
  background: #f5f5f5;
}

img {
  margin-top: 30px;
  margin-bottom: 30px;
}
</style>




// WEBPACK FOOTER //
// src/components/tutor/zdyjn_jjsj.vue